/** "Check before sharing" list — the engine's warnings, never hidden. */

import React from 'react';

interface Props {
  warnings: string[];
  title?: string;
  tone?: 'warning' | 'info' | 'danger';
}

const WarningsBox: React.FC<Props> = ({ warnings, title = 'Check before sharing', tone = 'warning' }) => {
  if (warnings.length === 0) return null;
  return (
    <div
      role={tone === 'danger' ? 'alert' : undefined}
      style={{
        padding: '12px 14px',
        borderRadius: 'var(--radius-md)',
        background: `var(--${tone}-soft)`,
        border: `1px solid var(--${tone})`,
        fontFamily: 'var(--font-sans)',
      }}
    >
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: `var(--${tone})`, marginBottom: 6 }}>{title}</div>
      <ul style={{ margin: 0, paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 4 }}>
        {warnings.map((w) => (
          <li key={w} style={{ fontSize: 13, color: 'var(--fg-2)' }}>
            {w}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WarningsBox;
